import React from 'react';
import { Form, Select } from 'antd';
import { ICountryOrState, IUserAddressRulesField } from 'base/interfaces/address'
import { getFormItemRules, getOptions } from '@base/account/address/utils';
import Iconfont from '@base/lib/Iconfont'
import { useTrans } from 'base/utils/i18n'

type IProps = {
    isDisabledSelectCountry: boolean;
    onSelectCountryHandle: any;
    countries: ICountryOrState[];
    itemRules: IUserAddressRulesField;
}

const CountryFormItem: React.FC<IProps> = (props) => {
    const {
        isDisabledSelectCountry,
        countries,
        itemRules,
        onSelectCountryHandle
    } = props;


    const {
        key,
        labelTitle,
        placeholder,
    } = itemRules;

    const { t } = useTrans();

    return (
        <Form.Item
            label={labelTitle}
            name={key}
            rules={getFormItemRules(itemRules)}
        >
            <Select
                disabled={isDisabledSelectCountry}
                getPopupContainer={trigger => trigger.parentElement}
                placeholder={placeholder}
                onChange={(e) => onSelectCountryHandle(e)}
                options={getOptions(countries)}
                notFoundContent={<p>{t('web_common_it_is_empty')}</p>}
                suffixIcon={<Iconfont className={'select-arrow icon-arrow-down'}/>}
            />
        </Form.Item>
    );
};

export default CountryFormItem
